import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../api"
import type { RedirectUrl } from "../common/RedirectUrl"

export type DealershipRedirectResponse = RedirectUrl | undefined

export const getDealershipRedirectRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, DealershipRedirectResponse> = {
	buildUrl: () => "/dealership-redirect",
	method: "get",
	path: "/dealership-redirect",
}
